export default __webpack_public_path__ + "static/media/ITR-6.1e2e934b.png";